/* eslint-disable */
import session from './session';

export default {
    getTaskList(filter) {
        return session.get(`maintenance/task/${filter}`);
    },
    getTask(id) {
        return session.get(`maintenance/task/${id}/`);
    },
    createTask(data) {
        return session.post(`maintenance/task/`, data);
    },
    updateTask(id, data) {
        return session.patch(`maintenance/task/${id}/`, data);
    },
    deleteTask(id) {
        return session.delete(`maintenance/task/${id}/`);
    },
    assignTask(id, data) {
        return session.post(`maintenance/task/${id}/assign/`, data);
    },
    completeTask(id, data) {
        return session.post(`maintenance/task/${id}/complete/`, data);
    },
    cancelTask(id, data) {
        return session.post(`maintenance/task/${id}/cancel/`, data);
    },
    getPlanList(filter) {
        return session.get(`maintenance/plan/${filter}`);
    },
    createPlan(data) {
        return session.post(`maintenance/plan/`, data);
    },
    updatePlan(id, data) {
        return session.patch(`maintenance/plan/${id}/`, data);
    },
    deletePlan(id) {
        return session.delete(`maintenance/plan/${id}/`);
    },
};
